






















































































































































































































































































































































































































































































































































































































































































































import { Vue as VueDecor, Component, Ref, Watch } from 'vue-property-decorator'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import CardDeProduto from '@/components/produto/CardDeProduto.vue'
import DialogoDeRetirarProduto from './DialogoDeRetirarProduto.vue'
import DialogoDeSelecionarVariante from '@/components/produto/DialogoDeSelecionarVariante.vue'
import {
	Venda,
	ItemDaVenda,
	ProdutoFilho,
	Desconto,
	FormProdutoSimples,
	ProdutoComVariantes,
	FormProdutoSimplesFilho,
	Categoria,
	FiltroDeBuscaDeProdutos,
	Loja,
	InfoNotaComplementar,
	type CamposFiscaisManuaisDigitacao,
	type CST,
	type TipoDeTransacaoDeRegraFiscal,
	type TipoDeTransacaoDeVenda,
} from '@/models'
import CardDeEntradas from './CardDeEntradas.vue'
import DialogoDeResumoDaEntrada from '@/components/venda/DialogoDeResumoDaEntrada.vue'
import DialogoDeFechamentoDeCaixa from '@/components/venda/DialogoDeFechamentoDeCaixa.vue'
import DialogoDeDevolucaoDeVenda from '@/components/venda/DialogoDeDevolucaoDeVenda.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import PluginModule from '@/store/vuex/aplicacao/PluginStore'
import {
	EmitirNotaUseCase,
	FecharCaixaUseCase,
	FindCategoriaUseCase,
	FindConfiguracaoDaContaUseCase,
	FindLojaUseCase,
	FindProdutoUseCase,		
} from '@/usecases'
import type { PagamentoServiceAdapter, NotaFiscalServiceAdapter } from '@/usecases'
import type { VendaServiceAdapter } from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DialogoDeMovimentacoes from '@/components/venda/DialogoDeMovimentacoes.vue'
import DialogoDeReimpressao from '@/components/venda/DialogoDeReimpressao.vue'
import DialogoDeAutenticacao from './DialogoDeAutenticacao.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import AplicarTabelaDePrecoUseCase from '@/usecases/tabela-de-precos/AplicarTabelaDePrecoUseCase'
import AplicarPrecoDeCustoUseCase from '@/usecases/tabela-de-precos/AplicarPrecoDeCustoUseCase'
import { converterProdutoParaProdutoSimples, obterQuantidadePesadaNaBalanca } from '@/shareds/produto-shareds'
import DialogoDeEdicaoDePagamento from '@/components/venda/DialogoDeEdicaoDePagamento.vue'
import DialogoDeConsultaDeProduto from './DialogoDeConsultaDeProduto.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import DialogoDeDescontoEmGrupo from './DialogoDeDescontoEmGrupo.vue'
import DialogoDeInformarNotaDeOrigem from './DialogoDeInformarNotaDeOrigem.vue'
import DialogoDeReabrirVenda from './DialogoDeReabrirVenda.vue'
import axios, { CancelTokenSource } from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { Inject } from 'inversify-props'
import Axios from 'axios'
import AlterarQuantidadeLimiteDoProduto from '@/components/ui/AlterarQuantidadeLimiteDoProduto.vue'
import Vue from "vue"
import VueQuagga from "vue-quaggajs"
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import DialogoDeDevolucaoDeVendaSemTurno from '@/components/venda/DialogoDeDevolucaoDeVendaSemTurno.vue'
import DialogoDeImportarPreVenda from './DialogoDeImportarPreVenda.vue'
import DialogoDeVincularChaveComItem from './DialogoDeVincularChaveComItem.vue'
import NotaComplementarView from './NotaComplementarView.vue'
import DialogoDeSelecaoDeDevolucaoDeSaida from './DialogoDeSelecaoDeDevolucaoDeSaida.vue'
import DialogoDeInformarRepresentante from './DialogoDeInformarRepresentante.vue'
import DialogoDeBuscarRegraBaseFiscal from './DialogoDeBuscarRegraBaseFiscal.vue'
import SeletorDeCst from '@/components/fiscal/SeletorDeCst.vue'
import SeletorDeCsosn from '@/components/fiscal/SeletorDeCsosn.vue'
import SeletorDeClassificacaoTributaria from '@/components/fiscal/SeletorDeClassificacaoTributaria.vue'
import SeletorDeCfop from '@/components/fiscal/SeletorDeCfop.vue'
import SeletorDeOrigem from '@/components/fiscal/SeletorDeOrigem.vue'
import CampoDePercentual from '@/components/ui/CampoDePercentual.vue'
import { regraPorEstadoParaCamposFiscaisManuaisDigitacao } from '@/shareds/fiscal/regraPorEstadoParaCamposFiscaisManuaisDigitacao'

Vue.use(VueQuagga);

const ULTIMA_VENDA_COM_ERRO = 'ULTIMA_VENDA_COM_ERRO'

const MSG_BLOQUEIO_DIGITACAO_MANUAL_OBRIGATORIOS =
	'Com digitação manual ativa, preencha os campos obrigatórios: CST de ICMS, PIS, COFINS e IBS/CBS, CFOP e classificação tributária.'

function estadoInicialCamposFiscaisManuaisDigitacao(): CamposFiscaisManuaisDigitacao {
	return {
		cstIcms: null,
		aliquotaIcms: 0,
		cstPis: null,
		aliquotaPis: 0,
		cstCofins: null,
		aliquotaCofins: 0,
		codigosDeBeneficio: '',
		cfop: '',
		reduzIcms: false,
		incluirFrete: false,
		reduzDifal: false,
		zerarBaseCalculoIcms: false,
		utilizarCstPisCofinsOrigem: false,
		reduzImpostosBcIBSCBS: false,
		cstIBSCBS: null,
		codigoClassificacaoTributaria: null,
		aliquotaIBS: 0,
		aliquotaCBS: 0,
		aliquotaFcp: 0,
		aliquotaMva: 0,
		codigoCreditoPresumido: '',
		aliquotaCreditoPresumido: 0,
		aliquotaDifICMS: 0,
		cstIpi: null,
		aliquotaIpi: 0,
		origem: null,
	}
}

@Component({
	components: {
		Confirmacao,
		CampoDeItemDeVenda,
		CardDeProduto,
		DialogoDeSelecionarVariante,
		CardDeEntradas,
		DialogoDeConsultaDeProduto,
		DialogoDeFechamentoDeCaixa,
		DialogoDeMovimentacoes,
		DialogoDeDevolucaoDeVenda,
		DialogoDeEdicaoDePagamento,
		DialogoDeReimpressao,
		DialogoDeDescontoEmGrupo,
		DialogoDeInformarNotaDeOrigem,
		DialogoDeReabrirVenda,
		DialogoDeRetirarProduto,
		DialogoDeAutenticacao,
		AlterarQuantidadeLimiteDoProduto,
		SeletorDeLojas,
		DialogoDeResumoDaEntrada,
		DialogoDeDevolucaoDeVendaSemTurno,
		DialogoDeImportarPreVenda,
		DialogoDeVincularChaveComItem,
		NotaComplementarView,
		DialogoDeSelecaoDeDevolucaoDeSaida,
		DialogoDeInformarRepresentante,
		DialogoDeBuscarRegraBaseFiscal,
		SeletorDeCst,
		SeletorDeCsosn,
		SeletorDeClassificacaoTributaria,
		SeletorDeCfop,
		SeletorDeOrigem,
		CampoDePercentual,
	},
})
export default class TelaDeEmissaoDeNotas extends VueDecor {
	@Ref() readonly selecaoDeVariante!: DialogoDeSelecionarVariante
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda
	@Ref() readonly botaoDeVerPagamentos!: { $el: HTMLButtonElement }
	@Ref() readonly cardDeEntradas!: CardDeEntradas
	@Ref() campoDeConsultaDePreco!: DialogoDeConsultaDeProduto
	@Ref() dialogoDeDesconto!: DialogoDeDescontoEmGrupo
	@Ref() dialogoDeInformarNotaDeOrigem!: DialogoDeInformarNotaDeOrigem
	@Ref() dialogoDeReabrirVenda!: DialogoDeReabrirVenda
	@Ref() dialogoDeRetirarProduto!: DialogoDeRetirarProduto
	@Ref() dialogoDeAutenticacao!: DialogoDeAutenticacao
	@Ref() alterarQuantidadeLimiteDoProduto!: AlterarQuantidadeLimiteDoProduto
	@Ref() dialogoDeImportarPreVenda!: DialogoDeImportarPreVenda
	@Ref() dialogoDeVincularChaveComItem!: DialogoDeVincularChaveComItem
	@Ref() dialogoDeSelecaoDeDevolucaoDeSaida!: DialogoDeSelecaoDeDevolucaoDeSaida
	@Ref() dialogoDeInformarRepresentante!: DialogoDeInformarRepresentante
	@Ref() confirmacaoDeDescartarNotaAtual!: Confirmacao

	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	@Inject('NotaFiscalServiceAdapter')
	private notaFiscalService!: NotaFiscalServiceAdapter

	version = process.env.PACKAGE_VERSION || ''
	findProdutoUseCase = new FindProdutoUseCase()
	findCategoriaUseCase = new FindCategoriaUseCase()
	fecharCaixaUseCase = new FecharCaixaUseCase()
	findLojaUseCase = new FindLojaUseCase()
	zIndex = 2
	requestsPendentes = 0
	pedindoCliente = false
	produtos: FormProdutoSimples[] = []
	buscandoCliente = false
	carregandoProdutos = true
	mostrarPagamento = false
	busca: FiltroDeBuscaDeProdutos = {
		tipos: ['Padrão', 'Com Variantes', 'Composto'],
	}
	categorias: Categoria[] = []
	cancelToken: CancelTokenSource | null = null
	parametroIdentificador: string | null = null
	infoNotaComplementar: InfoNotaComplementar | null = null
	mostrarDialogoSelecaoProduto = false
	mostrarDialogoLeituraDeCodigoBarras = false
	selecionandoProduto = false
	mostraDialogoDeImportarPreVenda = false
	permissaoConcedida: boolean | undefined = false
	tipoOperacao: string | null = null
	mostrarDialogoPrecoDeCusto = false
	utilizaPrecoDeCustoNaVenda = false
	mostrarDialogoNotaComplementar = false
	mostrarDialogoBuscarRegraBase = false
	carregandoRegraBaseFiscal = false

	camposFiscaisManuais: CamposFiscaisManuaisDigitacao = estadoInicialCamposFiscaisManuaisDigitacao()

	readerSize = {
		width: 860,
		height: 480,
	}

	showCamera = false
	valorLido: string | null = null
	buscandoProduto = false

	mostrarDialogoParaInformarEmail = false

	mostraTelaDeDevolucao = false
	mostraDialogoRepresentante = false
	preVendaIdImportada: string | null = null
	representanteImportado: any | null = null
	
	get devolucaoBuscada() {
		return this.$route.query.devolucaoBuscada
	}
	
	@Inject('PagamentoServiceAdapter')
	private pagamentoService!: PagamentoServiceAdapter

	findConfiguracaoDaContaUseCase = new FindConfiguracaoDaContaUseCase()

	set venda(venda: Venda | null) {
		VendaModule.setEmissaoEntradaAtual(venda)
	}

	get venda() {
		return VendaModule.emissaoEntradaAtual
	}

	get loja() {
		return VendaModule.lojaDaEntrada
	}

	get vendaComErro() {
		if (!this.venda) return false

		const ultimaVendaComErro: Venda | null  = localStorage[ULTIMA_VENDA_COM_ERRO] 
			? JSON.parse(localStorage[ULTIMA_VENDA_COM_ERRO]) 
			: null

		return ultimaVendaComErro && ultimaVendaComErro.identificador === this.venda?.identificador
	}

	get lojaDaEntrada() {
		return VendaModule.lojaDaEntrada
	}

	set lojaDaEntrada(loja: Loja | null) {
		VendaModule.setLojaDaEntrada(loja)
	}

	get digitacaoManualFiscalEmissaoNotas() {
		return VendaModule.digitacaoManualFiscalEmissaoNotas
	}

	get usaCsosnNoIcmsManual() {
		const rf = this.lojaDaEntrada?.regimeFiscal
		return rf === 'MEI' || rf === 'Simples Nacional'
	}

	get obrigatoriosCarimboFiscalManualPreenchidos(): boolean {
		const f = this.camposFiscaisManuais
		const cstPreenchido = (c: CST | null) =>
			!!c && String(c.codigo ?? '').trim() !== ''
		return (
			cstPreenchido(f.cstIcms)
			&& cstPreenchido(f.cstPis)
			&& cstPreenchido(f.cstCofins)
			&& cstPreenchido(f.cstIBSCBS)
			&& cstPreenchido(f.cstIpi)
			&& String(f.origem ?? '').trim() !== ''
			&& String(f.cfop ?? '').trim() !== ''
			&& String(f.codigoClassificacaoTributaria ?? '').trim() !== ''
		)
	}

	get digitacaoManualBloqueiaInclusaoPorCamposObrigatorios(): boolean {
		return this.digitacaoManualFiscalEmissaoNotas && !this.obrigatoriosCarimboFiscalManualPreenchidos
	}

	get podeConsultarProduto() {
		return UserLoginStore.permiteRegraDeNegocio('dna-do-produto')
	}

	get valorDoDesconto(){
		if(!this.descontoEmSerie) return ''
		return this.descontoEmSerie.valor
	}

	get precisaDeClienteAntesDeIncluirProduto(): boolean {
		if (!this.venda) return false
		if (this.venda.tipoDeTransacao === 'Complementar') return false
		if (this.venda.tipoNota !== 'Saída') return false
		return this.venda.cpfDoCliente == null || this.venda.cpfDoCliente === ''
	}

	get naoPodeIncluirProduto() {
		if (!this.venda) return true

		return this.venda.tipoDeTransacao === 'Complementar'
			|| ((this.venda.tipoDeTransacao === 'Devolução' || this.venda.tipoDeTransacao === 'Uniforme') && this.$route.query.devolucaoBuscada === 'true')
			|| this.buscandoCliente
			|| this.precisaDeClienteAntesDeIncluirProduto
			|| (this.venda.tipoDeTransacao === 'Uniforme' && this.venda.tipoNota === 'Entrada')
			|| this.digitacaoManualBloqueiaInclusaoPorCamposObrigatorios
	}

	get podeExibirMenuOpcoesVenda() {
		return this.venda && this.venda.tipoDeTransacao === 'Complementar'
	}

	abrirDialogoDeImportarPreVenda() {
		this.mostraDialogoDeImportarPreVenda = true
	}

	async confirmarDescarteDaNotaAtual() {
		if (!this.venda?.itens.length && !this.venda?.pagamentos.length) return true
		if (!this.validarPagamentosPorTefDaNotaAtual()) return false
		if (!await this.confirmacaoDeDescartarNotaAtual.mostrar()) return false

		VendaModule.iniciarNovaNota({
			identificador: this.venda?.identificador ?? '',
			lojaId: this.lojaDaEntrada?.id || '',
			tipoDeTransacao: this.venda?.tipoDeTransacao,
		})
		return true
	}

	validarPagamentosPorTefDaNotaAtual() {
		const pagamentosPorTef = VendaModule.emissaoEntradaAtual?.pagamentos?.filter(
			pagamento =>
				pagamento.tipoDePagamento.formaDePagamento === 'TEF Crédito' ||
				pagamento.tipoDePagamento.formaDePagamento === 'TEF Débito' ||
				pagamento.tipoDePagamento.formaDePagamento === 'TEF Pix',
		) ?? []

		if (pagamentosPorTef.length > 0) {
			AlertModule.setError(
				'Existe pagamento(s) por TEF autorizado(s) na nota atual. Não é possível importar uma pré-venda.',
			)
			return false
		}

		return true
	}

	async concluirCadastroNotaComplementar(infoNotaComplementar: InfoNotaComplementar) {
		if(!this.venda) return
		try {
			const emitente = await this.notaFiscalService.findEmitenteDaNota(infoNotaComplementar.chnfeReferencia)
			if(emitente) {
				this.venda.cliente = emitente
				this.venda.cpfDoCliente = emitente.cnpjOuCpf
			}

			this.infoNotaComplementar = infoNotaComplementar
			this.esconderDialogoNotaComplementar()
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	esconderDialogoNotaComplementar() {
		this.mostrarDialogoNotaComplementar = false
		this.$router.push({ name: this.$route.name as string, query: {} })
	}

	@Watch('venda')
	abrirDialogoDeVincularChaveComItem() {
		if(this.itensSemVinculos.length > 0 && (this.venda?.tipoDeTransacao === 'Devolução'
				|| this.venda?.tipoDeTransacao === 'Devolução de Transferência') && this.venda?.tipoNota === 'Saída') {
			this.dialogoDeVincularChaveComItem.mostra(this.itensSemVinculos, true)
		}
	}

	@Watch('venda.cpfDoCliente', { deep:true })
	abrirDialogoDeSelecionarDevolucaoDeSaida() {
		if(!this.venda) return

		if(this.venda.cpfDoCliente && ((this.venda.tipoNota === 'Saída' && this.venda.tipoDeTransacao === 'Devolução') || (this.venda.tipoDeTransacao === 'Uniforme' && this.venda.tipoNota === 'Entrada' && this.venda.cliente)
				|| (this.venda.tipoNota === 'Saída' && this.venda.tipoDeTransacao === 'Devolução de Transferência')) && this.venda.itens.length === 0) {
			this.dialogoDeSelecaoDeDevolucaoDeSaida.mostra(true)
		}
	}

	get itensSemVinculos() {
		return this.venda?.itens.filter(i => i.chaveNotaOrigem == null) || []
	}

	async abrirDialogoDeRemoverItens(){
		const resultado = await VendaModule.autenticarAcao({ regra: 'pode-excluir-item-de-venda' })
		if (!resultado?.autenticado) return
		this.dialogoDeRetirarProduto.mostrar()
	}

	async created() {
		const temDadosSalvos = !!localStorage.getItem('EMISSAO_ENTRADA_ATUAL_STORAGE')
		if (!temDadosSalvos) {
			this.lojaDaEntrada = null
			VendaModule.iniciarNovaNota({ identificador: '', lojaId: '' })
		}
		this.$router
			.push({
				name: this.$route.name as string,
				query: {},
			})
	}

	async buscarCategorias() {		
		const page = await this.findCategoriaUseCase.findAll({ size: -1 }, {})
		this.categorias = page.content
	}

	async buscarProdutos() {
		this.carregandoProdutos = true

		if (this.cancelToken) this.cancelToken.cancel()
		this.cancelToken = axios.CancelToken.source()

		const axiosConfig = {
			cancelToken: this.cancelToken.token,
		}

		try {
			const produtosPage = await this.findProdutoUseCase.find(this.busca, axiosConfig)
			this.produtos = produtosPage.content
			this.carregandoProdutos = false
		}
		catch(error) {
			if (Axios.isCancel(error))
				this.carregandoProdutos = false
		}
	}

	destroyed() {
		document.removeEventListener('keydown', this.atalhoDeSelecaoDeProduto)
	}

	mounted() {
		this.focarBusca()
		VendaModule.setDialogDeAutenticacao(this.dialogoDeAutenticacao)
	}

	async validarParametroDevolucao() {
		if (this.$route.query.identificador !== undefined) {
			this.parametroIdentificador = this.$route.query.identificador.toString()
		} else {
			this.parametroIdentificador = ''
		}
	}

	excluirPagamentos(){
		const { venda } = this
		if(!venda) return
		this.venda = {
			...venda,
			pagamentos: [],
		}
	}

	atalhoDeSelecaoDeProduto(event: KeyboardEvent) {
		if (event.altKey && event.key.toLowerCase() === 's') {
			this.focarBusca()
		}
	}

	aplicarDescontoNaVenda(desconto: number) {
		this.descontoEmSerie = desconto
			? {
				isPercentual: true,
				valor: desconto,
			}
			: null
	}

	@Watch('venda', { immediate: true, deep: true })
	onChangeVenda(venda) {
		const novaVenda = venda
		VendaModule.setEmissaoEntradaAtual(novaVenda)
	}

	get descontoEmSerie() {
		return VendaModule.descontoEmSerie
	}

	set descontoEmSerie(desconto: Desconto | null) {
		VendaModule.setDescontoEmSerie(desconto)
	}

	async irParaResumo() {
		const valorTotal = this.venda?.itens.reduce((total, item) => {
			return total + item.preco * item.quantidade;
		}, 0).toFixed(2)

		const cliente = this.venda?.cliente?.cnpjOuCpf || this.venda?.cpfDoCliente

		if (!cliente || !valorTotal || !this.venda) {
			AlertModule.setError("Defina um cliente antes de prosseguir.")
			return
		}
		
		const params = {
			tipoDeTransacao: this.venda.tipoDeTransacao,
			tipoNota: this.venda.tipoNota,
			lojaEmitente: this.loja?.id,
		}
		
		const notaJaEmitida = await this.notaFiscalService.findNotaDeMesmoValor(cliente, valorTotal, params)

		if (notaJaEmitida){
			AlertModule.setWarning("Já foi emitida uma nota de mesmo valor para este destinatário nos últimos 7 dias! " + notaJaEmitida)
		}

		this.mostraTelaDeResumo = true
	}

	iniciarNovaVenda() {
		this.requestsPendentes = 0
	}

	async finalizarVenda() {
		if (!this.venda) return

		try {
			
			await EmitirNotaUseCase({
				venda: this.venda,
				infoNotaComplementar: this.infoNotaComplementar || null,
			})

			this.iniciarNovaNota()
		} catch(error) {
			AlertModule.setError(error)
			throw error
		}

		this.mostraTelaDeResumo = false
		this.focarBusca()
		this.pedindoCliente = VendaModule.lembraDePedirOCliente
	}

	async validarTipoDeNota (item: ItemDaVenda) {
		if (this.venda?.tipoNota === 'Saída' && (this.venda.tipoDeTransacao === 'Devolução'
				|| this.venda.tipoDeTransacao === 'Devolução de Transferência')
				&& item.produto.sku && this.lojaDaEntrada) {

			try {
				this.buscandoCliente = true

				const itensIguaisAoItemAtual = this.venda.itens.filter(i => i.produto.id === item.produto.id) || []
				const quantidadeLidaDoProduto = item.quantidade + itensIguaisAoItemAtual.reduce((total, i) => total + i.quantidade, 0)

				const itemNotaResumido = await this.notaFiscalService.findReferenciaDaEntrada(
					item.produto.sku,
					this.lojaDaEntrada?.id,
					this.venda.cpfDoCliente ? this.venda.cpfDoCliente : '',
					quantidadeLidaDoProduto,
				)

				item.idItemNotaOrigem = itemNotaResumido.id
				item.chaveNotaOrigem = itemNotaResumido.chaveNotaOrigem

				this.incluirItemDeVenda(item)
			} catch (error: any) {
				this.dialogoDeInformarNotaDeOrigem.mostrar(item)
			} finally {
				this.buscandoCliente = false
				VendaModule.setCarregandoItensDaVenda(false)
			}
		} else {
			this.incluirItemDeVenda(item)
		}
	}

	get consultarPrecoDeCusto() {
		if (!this.venda) return false

		return this.venda.isBrinde ||
			this.venda.tipoDeTransacao === 'Uniforme' ||
			this.venda.tipoDeTransacao === 'Transferência' ||
			this.venda.tipoDeTransacao === 'Devolução de Transferência' ||
			(this.venda.tipoDeTransacao === 'Devolução' && this.venda.tipoNota === 'Saída') ||
			this.venda.tipoDeTransacao === 'Outros' || (this.venda.tipoDeTransacao === 'Venda' && this.utilizaPrecoDeCustoNaVenda)
	}

	carimboConfiguracaoFiscalManualAtual(): CamposFiscaisManuaisDigitacao | undefined {
		if (!VendaModule.digitacaoManualFiscalEmissaoNotas) return undefined
		try {
			return JSON.parse(JSON.stringify(this.camposFiscaisManuais)) as CamposFiscaisManuaisDigitacao
		} catch {
			return undefined
		}
	}

	carimbarItemComConfiguracaoFiscalManual(item: ItemDaVenda): ItemDaVenda {
		const carimbo = this.carimboConfiguracaoFiscalManualAtual()
		return {
			...item,
			camposFiscaisDigitacaoManual: carimbo,
		}
	}

	private tipoDeTransacaoDeVendaParaRegraFiscal(tipo: TipoDeTransacaoDeVenda): TipoDeTransacaoDeRegraFiscal {
		const map: Record<TipoDeTransacaoDeVenda, TipoDeTransacaoDeRegraFiscal> = {
			Venda: 'Venda',
			'Devolução': 'Devolução',
			'Transferência': 'Transferência',
			Outros: 'Outros',
			Conserto: 'Conserto',
			Ativo: 'Ativo',
			Consumo: 'Consumo',
			Uniforme: 'Uniforme',
			Complementar: 'Venda',
			'Devolução de Transferência': 'Transferência',
		}
		return map[tipo]
	}

	async aplicarRegraBaseFiscalDoProduto(produto: FormProdutoSimplesFilho) {
		if (!this.lojaDaEntrada) return
		if (!this.venda) return
		if (!this.venda.tipoDeTransacao) return
		if (!this.venda.tipoNota) return

		this.carregandoRegraBaseFiscal = true
		try {

			const ufDaLoja = this.lojaDaEntrada.endereco.uf
			const tipoDeCliente = !this.venda.cliente ?
				this.venda.tipoDeTransacao === 'Devolução' && this.venda.tipoNota === 'Saída' ?
					'Contribuinte'
					:
					'Não Contribuinte'
				:
				this.venda.cliente.inscricaoEstadual !== 'ISENTO' ?
					'Contribuinte'
					:
					'Não Contribuinte'

			const regra = await this.notaFiscalService.findRegraPorEstadoBase(
				produto.id,
				this.lojaDaEntrada.id,
				tipoDeCliente,
				!this.venda.cliente ? ufDaLoja : this.venda.cliente.enderecosAdicionais.find(e => e.isPadrao)?.endereco.uf ?? ufDaLoja,
				this.tipoDeTransacaoDeVendaParaRegraFiscal(this.venda.tipoDeTransacao),
				this.venda.tipoNota,
			)
			const camposFiscaisConvertidos = regraPorEstadoParaCamposFiscaisManuaisDigitacao(regra, {
				tipoDeTransacao: this.venda.tipoDeTransacao,
				tipoNota: this.venda.tipoNota,
				isConsignado: this.venda.isConsignado ?? false,
				isDemonstracao: this.venda.isDemonstracao ?? false,
				pontoDeVenda: this.venda.pontoDeVenda,
				demonstracaoConvertida: this.venda.demonstracaoConvertida ?? false,
			})
			this.camposFiscaisManuais = { ...this.camposFiscaisManuais, ...camposFiscaisConvertidos }
			this.mostrarDialogoBuscarRegraBase = false
			AlertModule.setSuccess(
				`Campos fiscais preenchidos com a regra base ${regra.nomeRegraFiscalBase} 
				do estado ${regra.regraPorEstado.ufOrigem} para o destino ${regra.regraPorEstado.ufDestino}.`,
			)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregandoRegraBaseFiscal = false
		}
	}

	async incluirItemDeVenda(item: ItemDaVenda) {
		if (!this.loja) return

		if (this.digitacaoManualBloqueiaInclusaoPorCamposObrigatorios) {
			AlertModule.setError(MSG_BLOQUEIO_DIGITACAO_MANUAL_OBRIGATORIOS)
			return
		}

		const tipoDeCliente = this.venda && this.venda.tipoDeCliente
			? this.venda.tipoDeCliente
			: null

		const itemComCarimbo = this.digitacaoManualFiscalEmissaoNotas
			? this.carimbarItemComConfiguracaoFiscalManual(item)
			: item

		const itens = this.normalizaCasoSejaComposto(itemComCarimbo).map(
			itemMap => ({
				...itemMap,
				desconto: this.descontoEmSerie || itemMap.desconto,
			}),
		)
		if (!this.venda) return
		try {
			++this.requestsPendentes
			let itensComPrecoAplicado

			if (this.consultarPrecoDeCusto) {
				itensComPrecoAplicado = await AplicarPrecoDeCustoUseCase({
					loja: this.loja,
					itens,
					tipoDeCliente,
				})
			} else {
				itensComPrecoAplicado = await AplicarTabelaDePrecoUseCase({
					loja: this.loja,
					itens,
					tipoDeCliente,
					validarLimiteDeProduto: true,
					vendaAtual: this.venda,
				})
			}

			if (!this.venda) return

			itensComPrecoAplicado.forEach(itemComPrecoAplicado => {

				if (!this.venda) return

				if (this.venda?.tipoNota === 'Saída' && (this.venda.tipoDeTransacao === 'Devolução' || this.venda.tipoDeTransacao === 'Uniforme'
					|| this.venda.tipoDeTransacao === 'Devolução de Transferência')) {
					this.venda = {
						...this.venda,
						itens: [
							...this.venda.itens,
							itemComPrecoAplicado,
						],
					}
					return
				}

				const indiceDoItemBipado = this.venda.itens.findIndex(
					( produto ) => produto.produto.id === item.produto.id && produto.idConjunto === null,
				)

				if (indiceDoItemBipado === -1) {
					this.venda.itens.unshift(itemComPrecoAplicado)
					return
				}
				const itemAnterior = this.venda.itens[indiceDoItemBipado]
				this.venda.itens.splice(indiceDoItemBipado, 1)

				const quantidadeTotalDoItem = itemAnterior.quantidade + item.quantidade

				this.venda.itens.unshift({
					...itemAnterior,
					quantidade: Number(quantidadeTotalDoItem.toFixed(3)),
					camposFiscaisDigitacaoManual: this.carimboConfiguracaoFiscalManualAtual(),
				})
			})

		} catch (error: any) {
			AlertModule.setError(error)	
			if(AlertModule.getErrorMsg === 'Produto tem limite, favor informar CPF'){
				this.cardDeEntradas.pedirCliente()
			} else if (AlertModule.getErrorMsg === 'Cliente já esgotou limite de compras desse produto no dia atual') {
				this.podeAlterarQuantidadeDeProduto(item)
			}
		} finally {
			--this.requestsPendentes
			VendaModule.setCarregandoItensDaVenda(false)
		}
		this.focarBusca()
	}

	async podeAlterarQuantidadeDeProduto(item: ItemDaVenda) {
		if (!this.loja) return

		const tipoDeCliente =
			this.venda && this.venda.tipoDeCliente ? this.venda.tipoDeCliente : null

		const itens = this.normalizaCasoSejaComposto(item).map(itemMap => ({
			...itemMap,
			desconto: this.descontoEmSerie || itemMap.desconto,
		}))

		if (!this.venda) return

		try {

			const itensComPrecoAplicado = await AplicarTabelaDePrecoUseCase({
				loja: this.loja,
				itens,
				tipoDeCliente,
				validarLimiteDeProduto: false,
				vendaAtual: this.venda,
			})
			this.permissaoConcedida = (await VendaModule.autenticarAcaoTelaDeCaixa({ 
				regra:'pode-alterar-quantidade-de-produto', 
			}))?.autenticado
			if (!this.permissaoConcedida || !this.venda) return 
			this.alterarQuantidadeLimiteDoProduto.mostrar(itensComPrecoAplicado[0])

		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	normalizaCasoSejaComposto(item: ItemDaVenda) {
		let itens: ItemDaVenda[] = []
		
		if (item.produto.tipo === 'Composto') {
			const idConjunto = uuidv4()

			itens = item.produto.itens.map(itemDoProduto => ({
				...item,
				produto: itemDoProduto.produto,
				quantidade: item.quantidade * itemDoProduto.quantidade,
				idConjunto: idConjunto,
				desconto: itemDoProduto.desconto,
			}))
		} else {
			itens = [item]
		}

		return itens
	}

	incluirProdutoNaVenda(produto: ProdutoFilho | FormProdutoSimplesFilho) {
		if (!this.venda) return
		try {
			const itemDeVenda: ItemDaVenda = {
				id: '',
				produto: converterProdutoParaProdutoSimples(produto),
				desconto: { isPercentual: true, valor: 0 },
				preco: produto.preco || 0,
				descontoVarejo: produto.descontoVarejo,
				quantidade: 1,
				quantidadeLida: 0,
				precoDeCusto: 0,
				idConjunto: null,
				percentualCashback: 0,
				diasParaEfetivarCashback: 0,
				isBrinde: false,
				idItemNotaOrigem: null,
				chaveNotaOrigem: null,
				diasParaExpirarCashback: 0,
				possuiDescontoPorTabela: false,
				valorDescontoRateadoDoItem: 0,
				itemDeDevolucao: false,
				isTotalmenteTrocado: false,
				motivoCancelamento: null,
				isCompra: false,
				idItemOrigem: '',
				isDaVendaReaberta: false,
				vendedor: null,
				autenticadoParaLiberarProdutoSemEstoque: false,
				vendaOrigemDoItem: null,
				valorFreteRateado: 0,
				isItemReferenteATroca: false,
				isDeOutraLoja: false,
				percentualDescontoTabelaPreco: 0,
				notaNaoEletronica: false,
				precoDeCustoReal: 0,
				skuPai: produto.tipo === 'Variante' ? produto.skuPai : produto.sku,
			};
			this.validarTipoDeNota(itemDeVenda)
			this.focarBusca()
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async selecionarProduto(produtoSimplificado: FormProdutoSimples) {
		try {
			this.selecionandoProduto = true
			this.mostrarDialogoSelecaoProduto = false
			if (produtoSimplificado.tipo === 'Com Variantes') {
				const produto = this.findProdutoUseCase.findProdutoById(produtoSimplificado.id)
				this.selecaoDeVariante.abrir(produto as Promise<ProdutoComVariantes>)
				this.mostrarDialogoSelecaoProduto = false
				return
			}

			const produto = await this.findProdutoUseCase.findProdutoById(produtoSimplificado.id)
			if (produto.tipo !== 'Com Variantes')
				this.incluirProdutoNaVenda(produto)
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.selecionandoProduto = false
		}
	}

	focarBusca() {
		if(this.$route.query.voltarPraPedido === 'true') return
		setTimeout(() => {
			this.campoDeBusca.focus()
		})
	}

	get mostraTelaDeResumo() {
		return this.$route.query.payment !== undefined ? true : false
	}

	set mostraTelaDeResumo(mostra: boolean | null | undefined) {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { ...this.$route.query, payment: mostra ? null : undefined },
			})
			.catch()
	}

	@Watch('mostraTelaDeResumo')
	onChangeMostraTelaDePagamento(mostra: boolean) {
		if (mostra) {
			PluginModule.emit('abrirPagamentos', { venda: this.venda })
			return
		}
		window.requestAnimationFrame(() => {
			this.botaoDeVerPagamentos.$el.focus()
		})
	}

	get mostraFechamento() {
		return this.$route.query.closing !== undefined
	}

	set mostraFechamento(mostra: boolean | null | undefined) {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { closing: mostra ? null : undefined },
			})
			.catch()
	}

	get mostraMovimentacao() {
		return this.$route.query['cash-handling'] !== undefined ? true : false
	}

	set mostraMovimentacao(mostra: boolean | null | undefined) {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { ['cash-handling']: mostra ? null : undefined },
			})
			.catch()
	}

	get mostrarReimpressao() {
		return this.$route.query['reimpressao'] !== undefined ? true : false
	}

	set mostrarReimpressao(mostra: boolean | null | undefined) {
		this.$router
			.push({
				name: this.$route.name as string,
				query: { ['comprovantes']: mostra ? null : undefined },
			})
			.catch()
	}

	get temRequisicoesPendentes() {
		return !!this.requestsPendentes
	}

	async beforeRouteEnter(to, from, next){
		if ( to.query.closing !== undefined && await VendaModule.moverParaMovimentacoesCasoNaoTenhaAnexo()) return
		next()
	}

	async abrirConsultaDePreco(){
		const resultado = await VendaModule.autenticarAcao({ regra: 'dna-do-produto' })
		if (!resultado?.autenticado) return
		this.campoDeConsultaDePreco.mostrar()
	}

	@Watch('busca', { deep: true })
	async onChangeBusca() {
		this.buscarProdutos()
	}

	async selecionarCategoria(categoria: Categoria, active: boolean) {
		this.busca.categorias = active ? [ categoria.id ] : undefined
		this.buscarProdutos()
	}

	async logIt(data: any) {
		this.showCamera = false
		this.buscandoProduto = true

		this.valorLido = data.codeResult.code

		if (this.valorLido && this.lojaDaEntrada) {
			try {
				const produto = await this.findProdutoUseCase.findProdutoComEstoque(
					this.valorLido,
					this.lojaDaEntrada.id,
				)

				const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()

				const quantidadeDeItens =
					produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida != 'MT'
						? 1
						: obterQuantidadePesadaNaBalanca(
							'',
							configuracaoDeConta?.medida || 6,
							configuracaoDeConta?.eans || 7,
							configuracaoDeConta?.casasNumericas || 4,
						)
				const item: ItemDaVenda = {
					id: '',
					produto: converterProdutoParaProdutoSimples(produto),
					quantidade: quantidadeDeItens,
					quantidadeLida: 0,
					desconto: { isPercentual: true, valor: 0.0 },
					preco: produto.preco||0,
					precoDeCusto: 0,
					idConjunto: null,
					descontoVarejo: 0,
					percentualCashback: 0,
					diasParaEfetivarCashback: 0,
					isBrinde: false,
					idItemNotaOrigem: null,
					chaveNotaOrigem: null,
					diasParaExpirarCashback: 0,
					possuiDescontoPorTabela: false,
					valorDescontoRateadoDoItem: 0,
					itemDeDevolucao: false,
					isTotalmenteTrocado: false,
					motivoCancelamento: null,
					isCompra: false,
					idItemOrigem: '',
					isDaVendaReaberta: false,
					vendedor: null,
					autenticadoParaLiberarProdutoSemEstoque: false,
					vendaOrigemDoItem: null,
					valorFreteRateado: 0,
					isItemReferenteATroca: false,
					isDeOutraLoja: false,
					percentualDescontoTabelaPreco: 0,
					notaNaoEletronica: false,
					precoDeCustoReal: 0,
					skuPai: produto.tipo === 'Variante' ? produto.skuPai : produto.sku,
				}

				this.validarTipoDeNota(item)
			} catch (error: any) {
				AlertModule.setError(error)
			} finally {
				this.mostrarDialogoLeituraDeCodigoBarras = false
			}
		}
	}

	@Watch('digitacaoManualFiscalEmissaoNotas')
	onMudancaDigitacaoManualFiscal(ativo: boolean) {
		if (!ativo) {
			this.camposFiscaisManuais = estadoInicialCamposFiscaisManuaisDigitacao()
		}
	}

	@Watch('camposFiscaisManuais.reduzIcms')
	onMudancaReduzIcmsManual(ativo: boolean) {
		if (!ativo) {
			this.camposFiscaisManuais.reduzDifal = false
		}
	}

	@Watch('$route.query.novaEntrada')
	onChangeNovaEntrada() {
		if (!this.$route.query.novaEntrada) return

		if (this.$route.query.novaEntrada === 'true') {
			VendaModule.iniciarNovaNota({identificador: '', lojaId: ''})

			this.$router
				.push({
					name: this.$route.name as string,
					query: {
						devolucaoBuscada: undefined,
					},
				})
		}

	}

	@Watch('loja')
	async onChangeLojaDaNota() {
		let identificador = ''
		let lojaId = ''
		if (this.lojaDaEntrada != null) {
			identificador = await this.vendaService.gerarIdentificadorDeVendaSemTurno(this.lojaDaEntrada.id || '')
			lojaId = this.lojaDaEntrada.id
		}

		VendaModule.iniciarNovaNota({ identificador, lojaId, tipoDeTransacao: this.venda?.tipoDeTransacao })
	}

	@Watch('venda.tipoNota')
	onChangeTipoNota() {
		if(this.venda && this.venda.itens.length > 0){
			this.venda.itens = []
			this.venda.cpfDoCliente = null
			this.venda.cliente = null 
		}

		if (this.lojaDaEntrada !== undefined &&
			(
				this.venda?.tipoDeTransacao === 'Devolução'
				|| this.venda?.tipoDeTransacao === 'Conserto'
			)
		&& this.venda.tipoNota === 'Entrada') {
			this.mostraTelaDeDevolucao = true
		} else {
			this.mostraTelaDeDevolucao = false
		}
	}

	@Watch('$route.query.devolucaoBuscada')
	onChangeDevolucaoBuscada() {
		if (this.$route.query.devolucaoBuscada === 'true') {
			this.mostraTelaDeDevolucao = false
		}
	}

	iniciarNovaNota() {
		VendaModule.iniciarNovaNota({identificador: '', lojaId: ''})
		this.$router
			.push({
				name: this.$route.name as string,
				query: {
					devolucaoBuscada: undefined,
				},
			})
	}

	@Watch('$route.query.iniciarComplementar')
	onChangeIniciarComplementar() {
		if (this.$route.query.iniciarComplementar === 'true') {
			this.mostrarDialogoNotaComplementar = true
		}
	}

	@Watch('venda.tipoDeTransacao')
	onChangeTipoDeTransacao() {
		switch(this.venda?.tipoDeTransacao) {
			case 'Venda': {
				if (this.venda.itens && this.venda.itens.length > 0) {
					this.venda.itens = [];
				}

				this.mostrarDialogoPrecoDeCusto = true
				break
			}
		}

		if (this.venda) this.venda.cpfDoCliente = null
	}

	@Watch('utilizaPrecoDeCustoNaVenda')
	async onChangeUtilizarPrecoDeCustoNaVenda() {
		if (this.utilizaPrecoDeCustoNaVenda) {
			if (!this.loja) return
			if (!this.venda) return

			const tipoDeCliente = this.venda && this.venda.tipoDeCliente
				? this.venda.tipoDeCliente
				: null
			const itens = this.venda.itens.map(
				itemMap => ({
					...itemMap,
					desconto: this.descontoEmSerie || itemMap.desconto,
				}),
			)

			const itensComPrecoAplicado = await AplicarPrecoDeCustoUseCase({
				loja: this.loja,
				itens,
				tipoDeCliente,
			})

			this.venda.itens = itensComPrecoAplicado
		}
	}

	confirmarPrecoDeCusto() {
		this.utilizaPrecoDeCustoNaVenda = true
		this.mostrarDialogoPrecoDeCusto = false
	}

	fecharDialogoPrecoDeCusto() {
		this.utilizaPrecoDeCustoNaVenda = false
		this.mostrarDialogoPrecoDeCusto = false
	}

	get questionarRepresentanteDaPreVenda(){
		return !!this.loja?.configuracaoDaLoja?.questionarRepresentanteDaPreVenda
	}

	async onPreVendaImportada(resultado: any) {
		if (this.venda?.tipoDeTransacao === 'Conserto') {
			this.mostrarDialogoPrecoDeCusto = true
		}

		if (this.utilizaPrecoDeCustoNaVenda) {
			if (this.loja && this.venda) {
				const tipoDeCliente = this.venda.tipoDeCliente
					? this.venda.tipoDeCliente
					: null
				const itens = this.venda.itens.map(
					itemMap => ({
						...itemMap,
						desconto: this.descontoEmSerie || itemMap.desconto,
					}),
				)

				const itensComPrecoAplicado = await AplicarPrecoDeCustoUseCase({
					loja: this.loja,
					itens,
					tipoDeCliente,
				})

				this.venda.itens = itensComPrecoAplicado
			}
		}

		if (!this.questionarRepresentanteDaPreVenda) return

		if (resultado?.isAtacado) {
			this.preVendaIdImportada = resultado.preVendaId
			this.representanteImportado = resultado.representante
			this.mostraDialogoRepresentante = true
		}
	}

	onRepresentanteConfirmado(){
		this.preVendaIdImportada = null
		this.representanteImportado = null
		this.mostraDialogoRepresentante = false
	}
}

